export { default } from './SectionHeading';



// WEBPACK FOOTER //
// ./src/components/molecules/SectionHeading/index.js